// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pwBzn","col":"styles_col__sBLQZ","actions":"styles_actions__1Gimu","conflict":"styles_conflict__auMfI"};